<template>
    <div class="notications">
        <v-alert v-if="showAlert" :type="alertType" dismissible @input="showAlert = false" :class="{ 'pre-line': isPreTranslated }">
            <span v-if="isPreTranslated">{{ alertText }}</span>
            <span v-else>{{ getTranslatedText(alertText) }}</span>
        </v-alert>
    </div>
</template>

<script>
import languageMixins from '@/mixins/language/language-mixins'
import EventBus from '@/utils/EventBus'

export default {
    mixins: [languageMixins],
    data() {
        return {
            showAlert: false,
            alertText: '',
            alertType: '',
            timeoutDuration: 3000,
            isPreTranslated: false,
        }
    },
    created() {
        EventBus.$on('show-notications', (param) => this.showAlertWithTimeout(param))
    },
    destroyed() {
        EventBus.$off('show-notications', () => {})
    },
    methods: {
        showAlertWithTimeout(param) {
            this.alertText = param.text
            this.alertType = param.type
            // If text contains newlines or is marked as pre-translated, display as-is
            this.isPreTranslated = param.preTranslated || (param.text && param.text.includes('\n'))

            this.showAlert = true
            setTimeout(() => {
                this.showAlert = false
            }, this.timeoutDuration)
        },
    },
}
</script>

<style lang="scss">
@import '~ThemePath/scss/common/_notications.scss';

.pre-line {
    white-space: pre-line;
}
</style>
